import { ArrowUpRight, X } from "lucide-react";
import type { ReactNode } from "react";

/** Presentation only: navigating back must never rejoin or stop media tracks. */
export function FloatingCallPanel({ label, count, onReturn, onMinimize, children }: {
  label: string; count: number; onReturn: () => void; onMinimize: () => void; children: ReactNode;
}) {
  return <section aria-label="Active call" className="media-floating-dock fixed bottom-[calc(5.5rem+env(safe-area-inset-bottom))] right-3 z-50 w-[min(360px,calc(100vw-1.5rem))] overflow-hidden rounded-2xl border border-cloud-200 bg-white/95 shadow-xl backdrop-blur-xl lg:right-4">
    <div className="flex items-center gap-1 border-b border-cloud-200 px-2 py-1">
      <button type="button" onClick={onReturn} aria-label={`Return to call: ${label}`} title="Return to call"
        className="flex min-h-11 min-w-0 flex-1 items-center gap-2 rounded-xl px-2 text-left hover:bg-cloud-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-strawberry-400">
        <span className="h-2 w-2 shrink-0 rounded-full bg-emerald-500" />
        <span className="min-w-0 flex-1"><span className="block truncate text-xs font-semibold text-cloud-800">{label}</span>
          <span className="block text-[10px] text-cloud-500">{count} connected · Return to call</span></span>
        <ArrowUpRight className="h-4 w-4 shrink-0 text-cloud-500" />
      </button>
      <button type="button" onClick={onMinimize} aria-label="Minimize call controls" title="Minimize call"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-cloud-500 hover:bg-cloud-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-strawberry-400"><X className="h-4 w-4" /></button>
    </div>
    {children}
  </section>;
}
